import React, { useState } from "react";
import MonoButton from "./MonoButton";

/**
 * Modal für Kursdatum-Änderung einer bestimmten Registrierung.
 * @param {number} registrationId - Die eindeutige ID aus course_registrations!
 */
const ChangeCourseDateModal = ({ registrationId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [customDate, setCustomDate] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/update_course_date.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          registrationId,
          custom_date: customDate,
        }),
      });

      const rawText = await res.text();
      console.log("RAW SERVER RESPONSE:", rawText);

      let result;
      try {
        result = JSON.parse(rawText);
      } catch (jsonErr) {
        console.error("Fehler beim Parsen der JSON-Antwort:", jsonErr);
        setMessage("Fehlerhafte Antwort vom Server – bitte später nochmal versuchen.");
        return;
      }

      setMessage(result.message);

      if (result.success) {
        setTimeout(() => {
          setIsOpen(false);
          window.location.reload();
        }, 1500);
      }
    } catch (err) {
      console.error("Netzwerkfehler oder Server nicht erreichbar:", err);
      setMessage("Verbindungsfehler – bitte Internet prüfen oder später erneut versuchen.");
    }
  };

  return (
    <>
      <MonoButton
        className="w-full text-xs mt-2"
        onClick={() => setIsOpen(true)}
      >
        Kursdatum ändern
      </MonoButton>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-gray-50 border border-gray-800 rounded-lg p-6 shadow-lg w-full max-w-md font-mono">
            <h2 className="text-xs font-bold text-center mb-4">Neues Kursdatum wählen</h2>
            <input
              type="date"
              className="px-4 py-2 rounded w-full mb-4 text-center font-mono"
              value={customDate}
              onChange={(e) => setCustomDate(e.target.value)}
            />
            <MonoButton className="w-full text-xs" onClick={handleSubmit}>
              Speichern
            </MonoButton>
            {message && <p className="p-6 text-xs bg-gray-950 rounded-lg text-white text-center">{message}</p>}
            <button
              className="mt-2 text-xs text-gray-400 underline w-full"
              onClick={() => setIsOpen(false)}
            >
              Abbrechen
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangeCourseDateModal;
